import { useTranslations } from '@vocab/react';
import { Box, Stack, Text } from 'braid-design-system';
import translations from './.vocab/index';
import { DollarBillsIcon } from './DollarBillsIcon';

export const SalariesEmptyState = ({
  companyName,
}: {
  companyName: string;
}) => {
  const { t } = useTranslations(translations);
  return (
    <Box padding="xlarge">
      <Stack space="large" align="center">
        <Box paddingY="xxsmall">
          <DollarBillsIcon />
        </Box>
        <Text tone="secondary">
          {t('companyName does not have any salaries listed right now.', {
            companyName,
          })}
        </Text>
      </Stack>
    </Box>
  );
};
